<template>
	<!-- <div> -->
		<v-container fluid>
			<v-parallax	src="https://images.unsplash.com/photo-1552049865-2ab6c008e179?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2550&q=80" height="400" >
				<v-row align="center" justify="center">
					<v-col cols="12" sm="7" offset="md-5" class="pl-4 pr-4">
						<p class="text-h6 text-md-h3 font-weight-thin">MARKET RESEARCH WITH MEISTERWORKS DOESN’T <i>JUST</i> PAY GREAT REWARDS!</p>
						<span class="text-body-1 text-md-h5 subheading">Have your say and make future products and services better</span>
						<p class="mt-4 text-right">
							<RegistrationModal color="green" :size="{}"></RegistrationModal>	
							<LoginModal color="black" :size="{}"></LoginModal>
							
						</p>
					</v-col>
				</v-row>
			</v-parallax>
			<v-container>
				<h4 id="howItWorks" class="mt-4 font-weight-bold grey--text text-center">How It Works</h4>		
				<v-row class="pb-4 mt-5 pt-4 white--background">
					<v-col cols="12" md="4">
						<RoundInfo icon="mdi-cash" text="No coins or tokens to collect" title="Real rewards every time" color="primary"></RoundInfo>
					</v-col>
					<v-col cols="12" md="4">
						<RoundInfo icon="mdi-chat-processing" text="Speak to a researcher directly" title="No Boring Online Surveys" color="green"></RoundInfo>
					</v-col>
					<v-col cols="12" md="4">
						<RoundInfo icon="mdi-party-popper" text="Try the latest ideas and protypes" title="Be the first to know" color="primary"></RoundInfo>
					</v-col>
				</v-row>
			</v-container>
			<v-row class="pb-4 mt-5 pt-4 primary--background" id="about">
				<v-col cols="12" md="6" class="pa-8">
					<div id="a" class="text-lg font-weight-light white--text text-justify">
						<p class="title">About Us</p>
						<p>Meisterworks conduct research in conjunction with government organisations, companies and charities in order to learn about how they and/or their products or services are doing, and how they could be improved.</p> 
						<p>We do this by setting appointments with members of the public and the organisations we work with so both can talk freely and exchange ideas and thoughts. </p>
						<p>This website is a central hub that lets you see and change your appointments, check privacy settings and provide consent for research you're taking part in, set preferences for reward payments and even access some appointments directly from your account. </p>
					</div>
				</v-col>
				<v-col cols="12" md="6" class="pa-8">
					<div class="text-lg font-weight-light white--text text-justify">
						<p class="title">Registering for a Study</p>
						<p>For most studies, we'll ask you to register your interest by filling in a short questionnaire online. We need this information to make sure that the research we're working on is a good fit for you, and to make sure that we invite individuals from a broad range of backgrounds. </p>
						<p>We'll likely also ask you to let us have your availability for a few appointment options to help us with scheduling.</p>
					</div>
				</v-col>
			</v-row>
			<v-row class="white--background">
				<v-col>
					<h4 id="recentStudies" class="mt-4 mb-1 font-weight-bold grey--text text-center">Recent Studies</h4>
					<div class="pa-4">
						<ExpandableGrid>
							<template v-slot:content>
								<GridPhoto 
								:badges="[{content: 'Online', color: 'primary'}, { content: '60 mins', color: 'primary'}]" 
								corner="£70 reward" 
								title="Parliament as a place to visit"
								background="https://images.unsplash.com/photo-1486299267070-83823f5448dd?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1351&q=80"></GridPhoto>
								<GridPhoto 
								:badges="[{content: 'Online', color: 'primary'}, { content: '30 mins', color: 'primary'}]" 
								corner="£40 reward" 
								title="Care Home Managers"
								background="https://images.unsplash.com/photo-1584515933487-779824d29309?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80"></GridPhoto>

								<GridPhoto 
								:badges="[{content: 'Phone', color: 'primary'}, { content: '30 mins', color: 'primary'}]" 
								corner="£40 reward" 
								title="Small Business Owners"
								background="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80"></GridPhoto>
								<GridPhoto 
								:badges="[{content: 'Face to Face', color: 'primary'}, { content: 'London', color: 'accent'}]" 
								corner="£90 reward" 
								title="New Model SUV Drivers"
								background="https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80"></GridPhoto>

								<GridPhoto 
								:badges="[{content: 'Online', color: 'primary'}, { content: '90 mins', color: 'primary'}, { content: '20 mins', color: 'primary'}]" 
								corner="30 reward" 
								title="Thinking of getting in to teaching"
								background="https://images.unsplash.com/photo-1577896851231-70ef18881754?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80"></GridPhoto>
								<GridPhoto 
								:badges="[{content: 'Phone', color: 'primary'}, { content: '60 mins', color: 'primary'}]" 
								corner="£50 reward" 
								title="Covid-19 Attitudes"
								background="https://images.unsplash.com/photo-1584265549884-cb8ea486a613?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80"></GridPhoto>

							</template>
						</ExpandableGrid>
						
					</div>	
				</v-col>
			</v-row>
<!-- 			<v-row>
				<Slides></Slides>
			</v-row> -->
			<v-row class="pb-4 mt-5 pt-4 white--background" id="contact">
				<v-col cols="12" md="4" class="pa-4">
					<v-card class="pa-5" color="primary" dark>
						
					<div class="font-weight-light">
						<p class="title">Contact Us.</p>
					</div>
					<p>							
						11-12 St. James's Square<br/>
						London<br/>
						SW1Y 4LB
					</p>
					<p>
						talk@m.works
					</p>
					</v-card>
				</v-col>
				<v-col cols="12" md="8" class="pa-4">
					<ContactForm :questions="questions" id="MeadowContactForm"></ContactForm>
				</v-col>
			</v-row>
		</v-container>	
</template>

<script>
// @ is an alias to /src
// import Slides from "@/components/Slides"
import LoginModal from "@/components/LoginModal"
import RegistrationModal from "@/components/RegistrationModal"
import RoundInfo from "@/components/RoundInfo"
import GridPhoto from "@/components/GridPhoto"
import ExpandableGrid from "@/components/ExpandableGrid"
import ContactForm from "../../../x.m.works/src/components/tools/ContactForm.vue"
export default {
	name: 'Home',
	components: {
		// Slides,
		LoginModal,
		RegistrationModal,
		ExpandableGrid, 
		RoundInfo, 
		GridPhoto,
		ContactForm
	}, 
	props: ["r"],
	data: () => {
		return {
			questions: [
				{ value: 'name', label: "Name", type: 'text-field'},
				{ value: 'email', label: "Email", type: 'text-field'},
				{ value: 'message', label: "Your Message", type: 'textarea'}
			]
		}
	}
}
</script>
